import React, {useMemo, useState} from 'react';
import './TeasorScriptDisplay.styles.scss';

function TeasorScriptDisplay({text}) {
  const [clipboardText, setClipboardText] = useState('Copy Text');

  const frames = Array.isArray(text) ? text : [];

  const copyableText = useMemo(() => {
    return frames
      .map((frameObj) => {
        const lines = [`Frame ${frameObj.frame}`];

        if (frameObj.mainTitle) {
          lines.push('Main Title');
          lines.push(frameObj.mainTitle);
        }

        if (frameObj.subheading) {
          lines.push('Subheading');
          lines.push(frameObj.subheading);
        }

        if (frameObj.onScreenText) {
          lines.push('On-screen Text');
          lines.push(frameObj.onScreenText);
        }

        if (frameObj.visual) {
          lines.push('Visual / Animation');
          lines.push(frameObj.visual);
        }

        return lines.join('\n');
      })
      .join('\n\n');
  }, [frames]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(copyableText);
      setClipboardText('Copied!');
      setTimeout(() => {
        setClipboardText('Copy Text');
      }, 2000);
    } catch (error) {
      console.error('Failed to copy text:', error);
      setClipboardText('Copy Failed');
      setTimeout(() => {
        setClipboardText('Copy Text');
      }, 2000);
    }
  };

  return (
    <div className="teasor-display-container">
      <div className="header">
        <h2>Storyboard for Video</h2>
        <p className="copy-text" onClick={handleCopy}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="icon-sm">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7 5C7 3.34315 8.34315 2 10 2H19C20.6569 2 22 3.34315 22 5V14C22 15.6569 20.6569 17 19 17H17V19C17 20.6569 15.6569 22 14 22H5C3.34315 22 2 20.6569 2 19V10C2 8.34315 3.34315 7 5 7H7V5ZM9 7H14C15.6569 7 17 8.34315 17 10V15H19C19.5523 15 20 14.5523 20 14V5C20 4.44772 19.5523 4 19 4H10C9.44772 4 9 4.44772 9 5V7ZM5 9C4.44772 9 4 9.44772 4 10V19C4 19.5523 4.44772 20 5 20H14C14.5523 20 15 19.5523 15 19V10C15 9.44772 14.5523 9 14 9H5Z"
              fill="currentColor"
            />
          </svg>
          {clipboardText}
        </p>
      </div>

      <div className="text-content">
        {frames.map((frameObj, index) => (
          <div key={frameObj.frame || index} className="story-frame">
            <h3 className="frame-title">{` ${frameObj.frame}`}</h3>

            {frameObj.mainTitle && (
              <div className="frame-section">
                <div className="section-label">Main Title</div>
                <div className="section-value">{frameObj.mainTitle}</div>
              </div>
            )}

            {frameObj.subheading && (
              <div className="frame-section">
                <div className="section-label">Subheading</div>
                <div className="section-value">{frameObj.subheading}</div>
              </div>
            )}

            {frameObj.onScreenText && (
              <div className="frame-section">
                <div className="section-label">On-screen Text</div>
                <div className="section-value">{frameObj.onScreenText}</div>
              </div>
            )}

            {frameObj.visualAnimation && (
              <div className="frame-section">
                <div className="section-label">Visual / Animation</div>
                <div className="section-value">{frameObj.visualAnimation}</div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default TeasorScriptDisplay;
